import { type UseQueryResult, useQuery } from 'react-query';
import {
  BrokerFixChannelSettingsService,
  Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto,
} from '../../services/wealthlane-award-settlement-services';

const useGetFixConfigById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId: string
): UseQueryResult<Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto> => {
  return useQuery(['getSandboxConfiguration', companyId], async () => {
    return await handleRequest(
      BrokerFixChannelSettingsService.getApiAwardSettlementApiAppBrokerFixChannelSettingsByBrokerCompany(
        companyId
      )
    );
  });
};

export default useGetFixConfigById;
